import React from 'react';
import { formatCurrency } from '../../../utils/formatters';

interface PriceFilterPopoverContentProps {
  priceRange: { min: string; max: string };
  onFilterChange: (field: string, value: any, applyImmediately?: boolean) => void;
}

export const PriceFilterPopoverContent: React.FC<PriceFilterPopoverContentProps> = ({
  priceRange,
  onFilterChange
}) => {
  const formatPriceInput = (val: string) => {
    const numeric = val.replace(/\D/g, '');
    if (!numeric) return '';
    return new Intl.NumberFormat('es-CO').format(parseInt(numeric, 10));
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wider mb-1.5">
            Desde
          </label>
          <div className="relative flex items-center">
            <span className="absolute left-3 text-sm font-semibold text-gray-400 pointer-events-none">
              $
            </span>
            <input
              type="text"
              inputMode="numeric"
              value={priceRange.min ? formatPriceInput(priceRange.min) : ''}
              onChange={(e) =>
                onFilterChange('priceRange', {
                  ...priceRange,
                  min: e.target.value.replace(/\D/g, '')
                })
              }
              className="w-full h-11 pl-7 pr-3 py-2 bg-white border border-gray-300 rounded-xl text-sm font-medium text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 transition-all shadow-sm"
              placeholder="0"
            />
          </div>
        </div>

        <div>
          <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wider mb-1.5">
            Hasta
          </label>
          <div className="relative flex items-center">
            <span className="absolute left-3 text-sm font-semibold text-gray-400 pointer-events-none">
              $
            </span>
            <input
              type="text"
              inputMode="numeric"
              value={priceRange.max ? formatPriceInput(priceRange.max) : ''}
              onChange={(e) =>
                onFilterChange('priceRange', {
                  ...priceRange,
                  max: e.target.value.replace(/\D/g, '')
                })
              }
              className="w-full h-11 pl-7 pr-3 py-2 bg-white border border-gray-300 rounded-xl text-sm font-medium text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 transition-all shadow-sm"
              placeholder="Sin límite"
            />
          </div>
        </div>
      </div>

      {(priceRange.min || priceRange.max) && (
        <div className="flex flex-wrap gap-2 pt-3 border-t border-gray-100">
          {priceRange.min && (
            <div className="flex items-center px-2.5 py-1 rounded-full border text-[11px] font-bold bg-green-50 text-green-700 border-green-200 shadow-sm">
              <span>Mín: {formatCurrency(parseInt(priceRange.min))}</span>
              <button
                type="button"
                onClick={() => onFilterChange('priceRange', { ...priceRange, min: '' }, true)}
                className="ml-1.5 p-0.5 hover:bg-green-200 rounded-full transition-colors text-green-600"
              >
                ✕
              </button>
            </div>
          )}
          {priceRange.max && (
            <div className="flex items-center px-2.5 py-1 rounded-full border text-[11px] font-bold bg-green-50 text-green-700 border-green-200 shadow-sm">
              <span>Máx: {formatCurrency(parseInt(priceRange.max))}</span>
              <button
                type="button"
                onClick={() => onFilterChange('priceRange', { ...priceRange, max: '' }, true)}
                className="ml-1.5 p-0.5 hover:bg-green-200 rounded-full transition-colors text-green-600"
              >
                ✕
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
